
// Old prices for tickets with discounts
const oldPrices = {
    // Early bird tickets with original pricing
    883552: 1200.00,  // Private: Early bird - Swiss Fintech Pass excl. Point Zero Forum (was CHF 1200)
    883553: 1200.00,  // Private: Early bird - Swiss Fintech Pass excl. Point Zero Forum (with promocode) (was CHF 1200)
};

// Validity dates for tickets
const validityDates = {
    // Early bird tickets valid until a certain date
    883552: "(until 31. march)",  // Private: Early bird
    883553: "(until 31. march)",  // Private: Early bird with promocode
};

/**
 * Get the old (original) price for a ticket type
 * @param {number} ticketTypeId - The ticket type ID
 * @returns {number|null} The old price or null if not found
 */
export const getTicketOldPrice = (ticketTypeId) => {
    return oldPrices[ticketTypeId] || null;
};

/**
 * Get the validity date text for a ticket type
 * @param {number} ticketTypeId - The ticket type ID
 * @returns {string|null} The validity date text or null if not found
 */
export const getTicketValidityDate = (ticketTypeId) => {
    return validityDates[ticketTypeId] || null;
};

export default {
    getTicketOldPrice,
    getTicketValidityDate
};
